import React from 'react';
import { WorkFromHomeIcon } from '@kallidus/common';
import { OfficeBuildingIcon } from '@Generic/icons';

export const ADMIN = { untranslatedTitle: 'navigation.admin.admin-tools' };
export const COMPANY = { untranslatedTitle: 'navigation.company', icon: <OfficeBuildingIcon /> };
export const HOME = { untranslatedTitle: 'navigation.home', icon: <WorkFromHomeIcon /> };
export const OUTBOX = { untranslatedTitle: 'navigation.admin.outbox' };
